import { SectionBrowser, PageHeader } from 'global/LandingPage';
import { ASSET_URL } from '../constants';
import keystatsContents from './content';

function Keystats() {
  return (
    <>
      <PageHeader
        title="Keystats"
        description="Tangkap peluang pasar lebih cepat dengan ringkasan kinerja yang disajikan dengan menarik"
      />
      {keystatsContents.map((content, index) => (
        <SectionBrowser
          title={content.title}
          image={`${ASSET_URL}${content.image}`}
          description={content.description}
          reverse={index % 2 === 0}
        />
      ))}
    </>
  );
}

export default Keystats;
